var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"center"},[_c('img',{staticStyle:{"vertical-align":"middle","height":"400px","margin":"10px"},attrs:{"src":require('@/assets/notFound.png')}}),_c('p',{staticClass:"parag"},[_vm._v("Missing Website Configuration!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }